import React from 'react'
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Box , Grid} from '@mui/material';
import Button from '@mui/material/Button';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        width: '600px',
        maxWidth: '60ppx',
    },

    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));
const ActiveBonusModal = ({ handleCloseOpenActive, openActive }) => {

    return (
        <>

            <BootstrapDialog
                onClose={handleCloseOpenActive}
                aria-labelledby="customized-dialog-title"
                open={openActive}
            >
                <Box sx={{ padding: '15px 20px' }}>
                    <Typography sx={{ color: '#15243E', fontSize: '18px', fontWeight: '600' }}>Activate Bonus</Typography>
                    <Typography sx={{ color: '#363853', fontSize: '14px', fontWeight: '400' }}>Activate cashback amounts for Amity University Online</Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={handleCloseOpenActive}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <Box>
                        <Box>
                            <Typography style={{ color: '#363853', fontSize: '16px', fontWeight: 600, marginBottom: '14px' }}>Are you sure you want to enable Amity University Online? This will:</Typography>
                        </Box>
                        <Box sx={{ marginBottom: '14px'}}>
                            <ul style={{ paddingLeft: '30px' }}>
                                <li style={{ color: '#363853', fontSize: '15px', fontWeight: 400, listStyle: 'circle' , marginBottom: '5px' }}>
                                    Turn on both undergraduate and postgraduate courses
                                </li>
                                <li style={{ color: '#363853', fontSize: '15px', fontWeight: 400, listStyle: 'circle' , marginBottom: '5px' }}>
                                 Restore all cashback amounts (or initiate earning of cashback amounts)
                                </li>
                                <li style={{ color: '#363853', fontSize: '15px', fontWeight: 400, listStyle: 'circle' , marginBottom: '5px' }}>
                                   Resume all referral activities for this university
                                </li>
                            </ul>

                        </Box>
                           <Box>
                            <Typography style={{ color: '#363853', fontSize: '16px', fontWeight: 500, marginBottom: '14px' }}>This action can be reversed later by re-enabling the courses.</Typography>
                        </Box>
                          <Box>
                            <Grid container spacing={2}>
                                <Grid size={6}>
                                    <Button onClick={handleCloseOpenActive} variant="outlined" sx={{textTransform: 'capitalize' , width: '100%' , borderRadius: '8px' , padding: '12px 16px' , color: '#363853' , fontSize: '15px' , border: '1px solid #ddd'}}>Cancel</Button>
                                </Grid>
                                <Grid size={6}>
                                    <Button variant="contained" sx={{textTransform: 'capitalize' , width: '100%' , borderRadius: '8px' , padding: '12px 16px' , color: '#fff' , fontSize: '15px' , background: '#1075FF'}}>Active Bonus</Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </DialogContent>
            </BootstrapDialog>
        </>
    )
}

export default ActiveBonusModal